export default __webpack_public_path__ + "static/media/updownArrow.38e8a201.svg";